export const V1_THROW_ERROR = 'V1_THROW_ERROR'

export default data => {
  return {
    type: V1_THROW_ERROR,
    data,
  }
}
